//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { apis } from 'utils/lib/apis';
import * as LicencesActions from './actions';
import { logToSentry } from "utils/networkErrorUtils";
//  ----------------------------------------------------------------------------
//  Thunks
//  ----------------------------------------------------------------------------
//  -- Create Licences --------------------
export const handleCreateLicences = (data) => async(dispatch) => {
    await dispatch(LicencesActions.createLicences());
    try {
        const licencesData = await apis.post('licencesRDS', `/addLicence`, {
            body: { ...data }
        });
        await dispatch(LicencesActions.createLicencesSuccess(licencesData));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'creating licences',
                error,
                module: 'LICENCES',
                operation: 'CREATE_LESSON'
            });
         }
        await dispatch(LicencesActions.createLicencesFail(error));
    }
};
//  -- List Licences ---------------
export const handleListLicences = () => async(dispatch) => {
    await dispatch(LicencesActions.listLicences());
    try {
        const licencesRDS = await apis.get('licencesRDS', `/getLicence`);
        await dispatch(LicencesActions.listLicencesSuccess(licencesRDS));
        return licencesRDS;
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'listing licences',
                error,
                module: 'LICENCES',
                operation: 'LIST_LESSON'
            });
         }
        await dispatch(LicencesActions.listLicencesFail(error));
    }
};


//  -- Update district Licences -------------------
export const handleUpdateDistrictLicences = (organizationID, data) => async (dispatch) => {
    // await dispatch(LicencesActions.updateOrganization());

    try {
        await apis.put('licencesRDS', `/updateDistrictLicence/${organizationID}`, {
            body: { ...data }
        });

        // await dispatch(LicencesActions.updateLicencesSuccess(updateLicence));
    } catch (error) {
        if(error&&error.message!="Network Error"){
            logToSentry({
                message: 'updating district licences',
                error,
                module: 'LICENCES',
                operation: 'UPDATE_DIFFERENTIATION_LESSON'
            });
         }
        // await dispatch(LicencesActions.updateOrganizationFail(error));
    }
};

//  -- Update School Licences -------------------



//  -- List Licences ---------------

export const handleSyncLicesneUses = (orgId, class_id) => async (dispatch) => {
    try {
        const licencesRDS = await apis.post('licencesRDS', `/license_map_by_class`, {
            body: {
                orgId,
                class_id
            }
        });
        return licencesRDS;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: '912-1 Error updating licesnes log',
                error,
                module: 'LICENCES',
                operation: 'EXPORT_USER_LESSON_LESSON'
            });
        }
    }
};
export const handlegetLicenseUtilization = async (orgId, type) =>  {
    try {
        const utilization_info = await apis.post('licencesRDS', `/get_license_info`, {
            body: {
                orgId,
                type
            }
        });
        return utilization_info;
    } catch (error) {
        if (error && error.message != "Network Error") {
            logToSentry({
                message: '912-1 Error updating licesnes log',
                error,
                module: 'LICENCES',
                operation: 'EXPORT_USER_LESSON_LESSON'
            });
        }
    }
};